import localeEs from '../../locales/es';

const { translation } = localeEs.es;

export const DATA = (
  t,
  crehanaBaseUrl = '',
  { countryPrefix, slugOrg = '', isAffiliate },
) => {
  const comunityMobile = [
    {
      id: 0,
      name: t('COMMUNITY_MENU_REMOTE_WORK', {
        defaultValue: translation.COMMUNITY_MENU_REMOTE_WORK,
      }),
      url: `${crehanaBaseUrl}/trabajo-remoto/`,
    },
    {
      id: 4,
      name: t('COMMUNITY_MENU_BLOG', {
        defaultValue: translation.COMMUNITY_MENU_BLOG,
      }),
      url: `${crehanaBaseUrl}${countryPrefix}/blog/?v1`,
    },
    {
      id: 1,
      name: t('COMMUNITY_MENU_LIVES', {
        defaultValue: translation.COMMUNITY_MENU_LIVES,
      }),
      url: `${crehanaBaseUrl}/live/`,
    },
    isAffiliate
      ? {
          id: 2,
          name: t('COMMUNITY_MENU_AFFILIATE', {
            defaultValue: translation.COMMUNITY_MENU_AFFILIATE,
          }),
          url: `${crehanaBaseUrl}/afiliado/`,
        }
      : null,
    {
      id: 3,
      name: t('COMMUNITY_MENU_RESOURCES', {
        defaultValue: translation.COMMUNITY_MENU_RESOURCES,
      }),
      url: `${crehanaBaseUrl}/recursos/herramientas/`,
    },

    {
      id: 5,
      name: t('COMMUNITY_MENU_PROJECTS', {
        defaultValue: translation.COMMUNITY_MENU_PROJECTS,
      }),
      url: `${crehanaBaseUrl}/proyectos/`,
    },
    {
      id: 6,
      name: t('COMMUNITY_MENU_COURSE_AGENDA', {
        defaultValue: translation.COMMUNITY_MENU_COURSE_AGENDA,
      }),
      url: `${crehanaBaseUrl}/agenda-cursos/`,
    },
  ].filter(Boolean);

  return {
    others: [
      {
        id: 1,
        name: t('COMMUNITY_MENU_NEW_COURSES', {
          defaultValue: translation.COMMUNITY_MENU_NEW_COURSES,
        }),
        url: `${crehanaBaseUrl}${countryPrefix}/cursos-nuevos/`,
      },
      {
        id: 2,
        name: t('COMMUNITY_MENU_COURSES_ON_OFFER', {
          defaultValue: translation.COMMUNITY_MENU_COURSES_ON_OFFER,
        }),
        url: `${crehanaBaseUrl}${countryPrefix}/cursos-ofertas/`,
      },
      {
        id: 3,
        name: t('COMMUNITY_MENU_SEE_ALL', {
          defaultValue: translation.COMMUNITY_MENU_SEE_ALL,
        }),
        url: `${crehanaBaseUrl}${countryPrefix}/cursos-online/?all=true`,
      },
    ],
    comunity: [
      {
        id: 0,
        name: t('COMMUNITY_MENU_REMOTE_WORK', {
          defaultValue: translation.COMMUNITY_MENU_REMOTE_WORK,
        }),
        url: `${crehanaBaseUrl}/trabajo-remoto/`,
      },
      {
        id: 7,
        name: t('COMMUNITY_MENU_BLOG', {
          defaultValue: translation.COMMUNITY_MENU_BLOG,
        }),
        url: `${crehanaBaseUrl}${countryPrefix}/blog/?v1`,
      },
      {
        id: 1,
        name: t('COMMUNITY_MENU_LIVES', {
          defaultValue: translation.COMMUNITY_MENU_LIVES,
        }),
        url: `${crehanaBaseUrl}/live/`,
      },
      {
        id: 3,
        name: t('COMMUNITY_MENU_RESOURCES', {
          defaultValue: translation.COMMUNITY_MENU_RESOURCES,
        }),
        url: `${crehanaBaseUrl}/recursos/herramientas/`,
      },
      {
        id: 4,
        name: t('COMMUNITY_MENU_COURSE_AGENDA', {
          defaultValue: translation.COMMUNITY_MENU_COURSE_AGENDA,
        }),
        url: `${crehanaBaseUrl}/agenda-cursos/`,
      },
      {
        id: 5,
        name: t('COMMUNITY_MENU_PROJECTS', {
          defaultValue: translation.COMMUNITY_MENU_PROJECTS,
        }),
        url: `${crehanaBaseUrl}/proyectos/`,
      },
      {
        id: 6,
        name: t('REFER_A_FRIEND', {
          defaultValue: translation.REFER_A_FRIEND,
        }),
        url: `/refiere-un-amigo/`,
      },
    ],
    comunityMobile,
    premiumCommunity: [
      {
        id: 1,
        name: t('COMMUNITY_MENU_LIVES', {
          defaultValue: translation.COMMUNITY_MENU_LIVES,
        }),
        url: `${crehanaBaseUrl}/live/`,
      },
      {
        id: 2,
        name: t('COMMUNITY_MENU_RESOURCES', {
          defaultValue: translation.COMMUNITY_MENU_RESOURCES,
        }),
        url: `${crehanaBaseUrl}/recursos/herramientas/`,
      },
      {
        id: 5,
        name: t('COMMUNITY_MENU_BLOG', {
          defaultValue: translation.COMMUNITY_MENU_BLOG,
        }),
        url: `${crehanaBaseUrl}${countryPrefix}/blog/?v1`,
      },
      {
        id: 3,
        name: t('COMMUNITY_MENU_COURSE_AGENDA', {
          defaultValue: translation.COMMUNITY_MENU_COURSE_AGENDA,
        }),
        url: `${crehanaBaseUrl}/agenda-cursos/`,
      },
      {
        id: 4,
        name: t('COMMUNITY_MENU_PROJECTS', {
          defaultValue: translation.COMMUNITY_MENU_PROJECTS,
        }),
        url: `${
          slugOrg
            ? `${crehanaBaseUrl}/org/${slugOrg}/proyectos/`
            : `${crehanaBaseUrl}/proyectos/`
        }`,
      },
    ],
  };
};

export const DATABR = (t, crehanaBaseUrl = '', { countryPrefix }) => ({
  others: [
    {
      id: 1,
      name: t('COMMUNITY_MENU_NEW_COURSES', {
        defaultValue: translation.COMMUNITY_MENU_NEW_COURSES,
      }),
      url: `${crehanaBaseUrl}${countryPrefix}/cursos-nuevos/`,
    },
    {
      id: 2,
      name: t('COMMUNITY_MENU_COURSES_ON_OFFER', {
        defaultValue: translation.COMMUNITY_MENU_COURSES_ON_OFFER,
      }),
      url: `${crehanaBaseUrl}${countryPrefix}/cursos-ofertas/`,
    },
    {
      id: 3,
      name: t('COMMUNITY_MENU_SEE_ALL', {
        defaultValue: translation.COMMUNITY_MENU_SEE_ALL,
      }),
      url: `${crehanaBaseUrl}${countryPrefix}/cursos-online/?all=true`,
    },
  ],
  comunity: [
    {
      id: 1,
      name: t('COMMUNITY_MENU_COURSE_AGENDA', {
        defaultValue: translation.COMMUNITY_MENU_COURSE_AGENDA,
      }),
      url: `${crehanaBaseUrl}/agenda-cursos/`,
    },
  ],
  comunityMobile: [
    {
      id: 1,
      name: t('COMMUNITY_MENU_COURSE_AGENDA', {
        defaultValue: translation.COMMUNITY_MENU_COURSE_AGENDA,
      }),
      url: `${crehanaBaseUrl}/agenda-cursos/`,
    },
  ],
  premiumCommunity: [
    {
      id: 1,
      name: t('COMMUNITY_MENU_COURSE_AGENDA', {
        defaultValue: translation.COMMUNITY_MENU_COURSE_AGENDA,
      }),
      url: `${crehanaBaseUrl}/agenda-cursos/`,
    },
  ],
});
